// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { McpTokenOut } from './mcpTokenOut.zod.ts';

export const McpTokenListOut = zod.object({
  "tokens": zod.array(McpTokenOut)
});

export type McpTokenListOut = zod.input<typeof McpTokenListOut>;
export type McpTokenListOutOutput = zod.output<typeof McpTokenListOut>;
